import { api, toCamelCase } from '../lib/api'
import { AuditLog } from '../types/auditLog'

export interface GetAuditLogsParams {
  userId?: number
  entityType?: string
  entityId?: number
  action?: string
  dateFrom?: string
  dateTo?: string
  skip?: number
  limit?: number
}

export const auditLogApi = {
  async getAll(params?: GetAuditLogsParams): Promise<AuditLog[]> {
    const queryParams: Record<string, string | number | undefined> = {}
    if (params?.userId) queryParams.user_id = params.userId
    if (params?.entityType) queryParams.entity_type = params.entityType
    if (params?.entityId) queryParams.entity_id = params.entityId
    if (params?.action) queryParams.action = params.action
    if (params?.dateFrom) queryParams.date_from = params.dateFrom
    if (params?.dateTo) queryParams.date_to = params.dateTo
    if (params?.skip !== undefined) queryParams.skip = params.skip
    if (params?.limit !== undefined) queryParams.limit = params.limit

    const response = await api.get('/audit-logs', { params: queryParams })
    return response.data.map((log: unknown) =>
      toCamelCase(log as Record<string, unknown>) as unknown as AuditLog
    )
  },
}
